var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 97,
    viewBox: "0 0 220 97",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.599 96.1278C164.469 96.1278 157.34 94.6931 150.923 91.8236L150.923 5.02166C157.34 1.4348 164.469 6.38652e-05 171.599 6.44885e-05C197.978 6.67947e-05 219.367 21.5212 219.367 48.0639C219.367 74.6067 197.978 96.1278 171.599 96.1278Z",
    fill: "url(#paint0_linear_purple)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.247 78.1928L135.247 11.4773C134.107 11.7641 133.124 12.0733 132.156 12.3781C130.701 12.8357 129.279 13.2832 127.405 13.6294C123.014 14.4406 120.447 14.6968 115.997 14.3468C111.15 13.9655 103.877 11.4773 103.877 11.4773L101.025 10.0426C101.025 10.0426 100.509 9.844 100.312 10.0426C100.116 10.2408 100.312 10.7599 100.312 10.7599C100.312 10.7599 101.025 12.912 101.738 13.6294L135.247 78.1928Z",
    fill: "url(#paint1_linear_purple)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1536 91.1437C63.6444 93.9914 56.412 96.1272 48.4563 96.1272C21.6962 96.8392 -0.00120364 75.4813 -0.00120121 47.716C-0.00119891 21.3747 21.6962 0.016775 48.4563 0.0167774C56.412 0.0167781 63.6444 2.15257 70.1536 5.00029L70.1536 91.1437Z",
    fill: "url(#paint2_linear_purple)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1916 37.0357C96.1916 37.0357 86.7894 20.6613 86.0661 19.2375C85.3431 84.0233 85.3681 86.1445 85.3681 86.1445C85.3681 86.1445 91.3441 83.2819 95.4684 82.5992C99.3695 81.9534 101.978 81.8873 105.594 82.5992C109.21 83.3111 112.826 84.0231 116.442 85.4469L120.059 86.8708C121.11 87.2836 121.5 87.4739 121.563 87.3986C121.604 87.3502 121.51 87.1927 121.37 86.9145C121.37 86.9145 120.059 84.0231 119.335 82.5992C112.103 67.6487 104.147 51.9862 96.1916 37.0357Z",
    fill: "url(#paint3_linear_purple)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_purple",
    x1: 9.94689,
    y1: 12.6732,
    x2: 121.372,
    y2: 90.6063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6926D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B14A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_purple",
    x1: 9.94689,
    y1: 12.6732,
    x2: 121.372,
    y2: 90.6063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6926D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B14A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_purple",
    x1: 9.94689,
    y1: 12.6732,
    x2: 121.372,
    y2: 90.6063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6926D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B14A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_purple",
    x1: 9.94689,
    y1: 12.6732,
    x2: 121.372,
    y2: 90.6063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6926D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B14A0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPurple);
export default __webpack_public_path__ + "static/media/logo-purple.54e5293a.svg";
export { ForwardRef as ReactComponent };